<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
import dayjs from 'dayjs'
import {
  queryPageLiveRooms,
  addLiveRoom,
  updateLiveRoom,
  deleteLiveRoom
} from 'server/modules/live'
import { message } from 'ant-design-vue'
// import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    List,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {},
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '直播间号',
          dataIndex: 'chatGroupId',
          key: 'chatGroupId',
          align: 'center'
        },
        {
          title: '直播间名称',
          align: 'center',
          dataIndex: 'chatGroupName',
          key: 'chatGroupName'
        },
        {
          title: '直播流地址',
          dataIndex: 'liveStreamUrl',
          key: 'liveStreamUrl',
          align: 'center'
        },
        {
          title: '直播开始时间',
          dataIndex: 'expStartDate',
          key: 'expStartDate',
          align: 'center'
        },
        {
          title: '直播结束时间',
          dataIndex: 'expEndDate',
          key: 'expEndDate',
          align: 'center'
        },
        {
          title: '直播间状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: '入口开关（PDP）',
          dataIndex: 'pdp',
          key: 'pdp',
          align: 'center'
        },
        {
          title: '入口开关（Collection）',
          dataIndex: 'collection',
          key: 'collection',
          align: 'center'
        },
        {
          title: '入口开关（首页）',
          dataIndex: 'home',
          key: 'home',
          align: 'center'
        },
        {
          title: '入口开关（专题页）',
          dataIndex: 'specialPage',
          key: 'specialPage',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      initList: () => {
        state.getTabList()
      },
      //table数据
      getTabList: () => {
        const param = {
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize
        }
        queryPageLiveRooms(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      modalVisible: false,
      formRef: null,
      form: {},
      editType: '',
      //校验
      rules: {
        chatGroupId: [{ required: true, message: '请输入直播间号！' }],
        chatGroupName: [{ required: true, message: '请输入直播间名！' }],
        liveStreamUrl: [{ required: true, message: '请输入直播流地址' }],
        emptyTime: [
          { required: true, message: '请输入直播开始时间和结束时间！' }
        ],
        // leftGoodsSearchType: [{ required: true, message: '请选择！' }],
        // flowGoodsSearchType: [{ required: true, message: '请选择！' }],
        leftSeoUrl: [{ required: true, message: '请输入seoUrl！' }],
        flowSeoUrl: [{ required: true, message: '请输入seoUrl！' }]
      },
      add: () => {
        state.editType = 1
        state.modalVisible = true
      },
      changeRangePicker() {
        state.form.expStartDate =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[0]).format('YYYY-MM-DD HH:mm:ss')
            : ''
        state.form.expEndDate =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[1]).format('YYYY-MM-DD HH:mm:ss')
            : ''
        console.log(state.form.expStartDate)
        console.log(state.form.expEndDate)
      },
      //添加直播头像
      imageType1: {
        tip: '尺寸 44*44',
        size: 2048,
        width: 44,
        height: 44
      },
      //获取直播头像图片地址
      setFaceUrl: url => {
        state.form.faceUrl = url
        state.formRef.clearValidate(['faceUrl'])
      },
      //删除直播头像图片
      delFaceImg: () => {
        state.form.faceUrl = ''
      },
      //添加直播封面
      imageType2: {
        tip: '',
        size: 2048
      },
      //获取直播封面图片地址
      setBgUrl: url => {
        state.form.bgUrl = url
        state.formRef.clearValidate(['bgUrl'])
      },
      //删除直播封面图片
      delBgImg: () => {
        state.form.bgUrl = ''
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {}
        state.modalVisible = false
      },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            if (state.form.id) {
              updateLiveRoom(state.form)
                .then(e => {
                  if (e.success) {
                    message.success('更新成功')
                    state.formRef.clearValidate()
                    state.form = {}
                    state.modalVisible = false
                    state.initList()
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addLiveRoom(state.form)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {}
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: info => {
        if (info) {
          state.form = {
            ...info,
            emptyTime: [dayjs(info.expStartDate), dayjs(info.expEndDate)]
          }
          state.editType = 2
          state.modalVisible = true
        }
      },
      handleDel: info => {
        if (info) {
          deleteLiveRoom(info)
            .then(e => {
              if (e.success) {
                if (e.data.succes) {
                  message.success('删除成功')
                  state.initList()
                } else {
                  message.warning(e.data.data)
                }
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      },
      handleOpen: info => {
        if (info) {
          const data = {
            id: info.id,
            pdp: info.pdp,
            collection: info.collection,
            specialPage: info.specialPage,
            home: info.home
          }
          updateLiveRoom(data)
            .then(e => {
              if (e.success) {
                message.success('设置成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
    })
    onMounted(() => {
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
